import clsx from "clsx";
import { SharedIcon } from "../shared/shared-icon";

export function FollowMemberButton({
  isFollowing = false,
  isLoading = false,
  toggleClickHandler = () => {},
  isSmall = false,
  followTitle,
  followingTitle,
  hasIcon,
  ...props
}) {
  return (
    <button
      type="button"
      className={clsx({
        "follow-member-button follow-member-button--mt-30": !isSmall,
        "follow-member-button--following": !isSmall && isFollowing,
        "follow-member-button-small": isSmall,
        "follow-member-button-small--following": isSmall && isFollowing,
      })}
      onClick={(e) => {
        e.stopPropagation();
        toggleClickHandler();
      }}
      {...props}
    >
      {isLoading && (
        <SharedIcon
          iconName="#sprite-spinner"
          className="animate-spin"
        />
      )}
      {!isLoading && (
        <div className="follow-member-button__text-wrapper">
          <span className="follow-member-button__text">
            {isFollowing ? followingTitle : followTitle}
          </span>
          {hasIcon && (
            <SharedIcon
              iconName={
                isFollowing
                  ? "#sprite-icon-user-check"
                  : "#sprite-icon-user-plus"
              }
              className="follow-member-button__icon"
            />
          )}
        </div>
      )}
    </button>
  );
}
